<template>
    <div class="home-bill flex justify-around align-center">
        <div class="home-bill-item flex flex-column align-center justify-around" v-for="(item, index) in billData" :key="index" @click="toPage(item)">
            <span class="home-bill-item-num">{{ item.value }}</span>
            <span>{{ item.label }}</span>
        </div>
    </div>
</template>

<script>
import { queryBindPlateNumAndCouponNum } from "@/api/api";
import { obj2Param } from "@/libs/tools";

export default {
    name: "HomeBill",
    data() {
        return {
            billData: [
                {
                    label: "待缴费用(元)",
                    value: "0.00",
                    route: "/pay/waitPay",
                },
                {
                    label: "待缴订单(笔)",
                    value: "0",
                    route: "/pay/waitPay",
                },
                // {
                //     label: "优惠券数量(张)",
                //     value: "0.00",
                //     route: "/mine/wallet",
                // },
            ],
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            queryBindPlateNumAndCouponNum({ type: 1 }).then((res) => {
                this.billData[0].value = res.data.arrearageMoney ? Number(res.data.arrearageMoney).toFixed(2) : "0.00";
                this.billData[1].value = res.data.arrearageOrderNum;
            });
        },
        toPage(item) {
            let obj = {
                token: localStorage.getItem("token"),
                userId: localStorage.getItem("userId"),
                xcxOpenId: localStorage.getItem("openId"),
                plateNum: localStorage.getItem("openId"),
            };
            let str = obj2Param(obj);
            window.location.href = `${process.env.VUE_APP_BASE_API}qginsideparking/page/plateNumBill?${str}`;
        },
    },
};
</script>

<style lang="less" scoped>
.home-bill {
    width: 702px;
    height: 150px;
    background: #f5f8fa;
    border-radius: 16px;
    padding: 24px;
    .home-bill-item {
        color: #999999;
        .home-bill-item-num {
            font-size: 40px;
        }
        &:nth-child(1) {
            .home-bill-item-num {
                font-size: 40px;
                color: #f72d2d;
            }
        }
        // &:nth-child(2) {
        //     position: relative;
        //     &::after {
        //         content: "";
        //         position: absolute;
        //         left: -43px;
        //         width: 1px;
        //         height: 102px;
        //         background: #dadada;
        //         border-radius: 1px;
        //     }
        // &::before {
        //     content: "";
        //     position: absolute;
        //     right: -43px;
        //     width: 1px;
        //     height: 102px;
        //     background: #dadada;
        //     border-radius: 1px;
        // }
        // }
    }
}
</style>
